
import { Fragment, useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import PageNotFound from "../../../components/404page/PageNotFound";
import {
    getDetails,
    paymentEligibility,
    finishPayment,
} from "../../../actions/admin/quotation";
import {
    flywireAddPaymentMethod,
} from "../../../actions/admin/flywire";
import { getLocationByAddress } from "../../../actions/googleAPI";
import moment from "moment";
import { Link, useHistory } from "react-router-dom/cjs/react-router-dom";
import LanguageCard from "../../../components/layout-new-theme/LanguageCard";
import { useDispatch, useSelector } from "react-redux";
import jwtDecode from "jwt-decode";
import CustomerLogin from "../../../components/auth/CustomerLogin";
import CustomerRegister from "../../../components/auth/CustomerRegister";
import QuotationModal from "../../../components/admin/quotation/QuotationModal";
import { useTranslation } from "react-i18next";
import ReactTooltip from "react-tooltip";
import { setLanguage } from "../../../actions/admin/settings";
import TNCTables from "../../../components/admin/quotation/TNCTables";
import PaymentMethodSelectionModal from "../../../components/admin/quotation/PaymentMethodSelectionModal";
import AlertModal from "../../../components/AlertModal";
import { PDFDownloadLink, PDFViewer, pdf } from "@react-pdf/renderer"
import { saveAs } from 'file-saver';
import QuotationDocument from "../../../components/admin/quotation/_components/pdf/QuotationDocument"
import ClientInfoFormModal from "./_components/modals/ClientInfoFormModal";
import {
    getAdditionalGroups,
    getAllAdditionalItems,
    computeQuotationTotalAmount,
    computeStandaloneItemsTotal,
} from "../../../components/admin/quotation/_utils/quotationTotals";
import Footer from "../../../components/layout-new-theme/Footer";
import {
    ArrowRightIcon,
    PrintIcon,
    DownloadNarrowIcon,
    CollapseDownIcon,
} from "../../../components/icons";

const logo = "https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/revamp_ui_assets/images/tlf-logo-cropped.png";
const logoMobile = "https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/revamp_ui_assets/images/tlf-logo-cropped-mobile.png";
const tlf_logo_quotation = "https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/revamp_ui_assets/images/tlf-logo-quotation.png";
const QuotationSkeleton = () => (
    <div className="container-md pt-5 pb-5">
        {/* Action buttons */}
        <div className="d-none d-md-flex gap-2 mb-4">
            <div className="tw:h-9 tw:w-20 tw:animate-pulse tw:rounded tw:bg-gray-200" />
            <div className="tw:h-9 tw:w-28 tw:animate-pulse tw:rounded tw:bg-gray-200" />
        </div>

        {/* TO / FROM info */}
        <div className="bg-white rounded p-4 mb-4">
            <div className="row g-4">
                <div className="col-md-6">
                    <div className="tw:h-3 tw:w-8 tw:animate-pulse tw:bg-gray-200 tw:mb-3" />
                    <div className="tw:h-5 tw:w-48 tw:animate-pulse tw:bg-gray-200 tw:mb-2" />
                    <div className="tw:h-4 tw:w-64 tw:animate-pulse tw:bg-gray-200 tw:mb-2" />
                    <div className="tw:h-4 tw:w-40 tw:animate-pulse tw:bg-gray-200" />
                </div>
                <div className="col-md-6">
                    <div className="tw:h-3 tw:w-10 tw:animate-pulse tw:bg-gray-200 tw:mb-3" />
                    <div className="tw:h-5 tw:w-56 tw:animate-pulse tw:bg-gray-200 tw:mb-2" />
                    <div className="tw:h-4 tw:w-48 tw:animate-pulse tw:bg-gray-200" />
                </div>
            </div>
        </div>

        {/* Quotation info (issue date, valid until) */}
        <div className="bg-white rounded p-4 mb-4">
            <div className="row g-3">
                {[1, 2, 3].map((i) => (
                    <div key={i} className="col-md-4">
                        <div className="tw:h-3 tw:w-20 tw:animate-pulse tw:bg-gray-200 tw:mb-2" />
                        <div className="tw:h-5 tw:w-32 tw:animate-pulse tw:bg-gray-200" />
                    </div>
                ))}
            </div>
        </div>

        {/* Table */}
        <div className="rounded overflow-hidden mb-4" style={{ border: "1px solid #dee2e6" }}>
            {/* Header */}
            <div className="tw:h-10 tw:bg-gray-800" />
            {/* Rows */}
            {[1, 2, 3, 4].map((i) => (
                <div key={i} className="d-flex gap-3 p-3" style={{ borderBottom: "1px solid #dee2e6" }}>
                    <div className="tw:h-4 tw:w-[15%] tw:animate-pulse tw:bg-gray-200 tw:rounded" />
                    <div className="tw:h-4 tw:flex-1 tw:animate-pulse tw:bg-gray-200 tw:rounded" />
                    <div className="tw:h-4 tw:w-[12%] tw:animate-pulse tw:bg-gray-200 tw:rounded" />
                    <div className="tw:h-4 tw:w-[5%] tw:animate-pulse tw:bg-gray-200 tw:rounded" />
                    <div className="tw:h-4 tw:w-[12%] tw:animate-pulse tw:bg-gray-200 tw:rounded" />
                </div>
            ))}
            {/* Subtotal */}
            <div className="d-flex justify-content-end gap-4 p-3 tw:bg-gray-100">
                <div className="tw:h-4 tw:w-20 tw:animate-pulse tw:bg-gray-300 tw:rounded" />
                <div className="tw:h-4 tw:w-32 tw:animate-pulse tw:bg-gray-300 tw:rounded" />
            </div>
            {/* Total */}
            <div className="d-flex justify-content-end gap-4 p-3 tw:bg-gray-800">
                <div className="tw:h-5 tw:w-16 tw:animate-pulse tw:bg-gray-600 tw:rounded" />
                <div className="tw:h-5 tw:w-36 tw:animate-pulse tw:bg-gray-600 tw:rounded" />
            </div>
        </div>
    </div>
);

export const QuotationLinkPage = () => {
    const dispatch = useDispatch();
    const { t, i18n } = useTranslation();
    const settings = useSelector((state) => state.setting);
    const { quotationId } = useParams();
    const [quotationDetail, setQuotationDetail] = useState(null);
    const [error, setError] = useState(false);
    const [isShow, setIsShow] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [selectedPaymentMethod, setSelectedPaymentMethod] = useState(null);
    const [showModaSelectPaymentMethod, setShowModaSelectPaymentMethod] = useState(false);
    const [showModalAlert, setShowModalAlert] = useState(false);
    const [modalAlertText, setmodalAlertText] = useState("");
    const [isPrint, setIsPrint] = useState(false);
    const [openItems, setOpenItems] = useState(["00"]); // State to track open items
    const [showTNCTables, setShowTNCTables] = useState(true);
    const [showClientInfoModal, setShowClientInfoModal] = useState({
        show: false,
        type: "pay" //pay or download
    });
    const [isMainButtonVisible, setIsMainButtonVisible] = useState(true)
    const [isLoading, setIsLoading] = useState(true)
    const mainPayButtonRef = useRef(null)
    const [isMobileButtonVisible, setIsMobileButtonVisible] = useState(true)
    const mobilePayButtonRef = useRef(null)

    const handleSelectedPaymentMethod = (id) => setSelectedPaymentMethod(id);

    const handleCloseClientInfoModal = () => setShowClientInfoModal({ ...showClientInfoModal, show: false });

    const handleOpenClientInfoModal = (type) => {
        setShowClientInfoModal({
            show: true,
            type: type
        });
    }

    const formatMomentDate = {
        "EN": "MMMM D, YYYY",
        "en": "MMMM D, YYYY",
        "JP": "YYYY年M月D日",
        "jp": "YYYY年M月D日",
    }

    const bookingItemsDetailOrder = [
        "charterCost",
        "lateNightFee",
        "discount",
        "tollFee",
        "longDistanceSurcharge",
        "driverAccomodationTotal"
    ]

    useEffect(() => {
        if (history.location.search.includes("lang")) {
            const lng = history.location.search.split("=");
            langChange(lng[1]);
        } else {
            langChange(lang);
        }
    }, []);

    const history = useHistory();
    const lang = i18n.language || localStorage.getItem("lang") || "EN";
    moment.locale(lang?.toUpperCase() === "EN" ? "en" : "ja");
    if (lang?.toUpperCase() === "EN" || lang?.toUpperCase() === "en") {
        moment.locale("en");
    } else {
        moment.locale("ja");
    }

    const langChange = (lng) => {
        if (lng === null) return;

        i18n.changeLanguage(lng.toLowerCase());
        localStorage.setItem("lang", lng);
        dispatch(setLanguage(lng.toUpperCase()));
    };

    const handleCloseModalAlert = () => {
        setShowModalAlert(false);
    };

    const handleModalSelectPaymentMethod = (value) => setShowModaSelectPaymentMethod(value);

    useEffect(() => {
        if (quotationId) {
            handleFetchDetailQuotation(quotationId);
        } else {
            setError(true);
        }
    }, []);

    const checkToken = () => {
        try {
            const token = localStorage.getItem("token");
            if (!token) {
                setShowModal(true);
                return;
            }
            const decodedJwt = jwtDecode(token);
            const tokenUserId = decodedJwt?.user?.id?._id ?? decodedJwt?.user?.id;
            if (tokenUserId !== quotationDetail.user._id) {
                setShowModal(true);
            } else {
                setIsShow(true);
            }
        } catch {
            setShowModal(true);
        }
    };

    useEffect(() => {
        if (quotationDetail !== null && quotationDetail.user) {
            if (quotationDetail.user.signUpStatus !== "QUOTATION_GUEST") {
                checkToken();
            } else {
                setIsShow(true);
            }
        }
    }, [quotationDetail]);

    const handleFetchDetailQuotation = async (quotationId) => {
        try {
            setIsLoading(true);
            var res = await getDetails(quotationId);

            if (res.status === 401 || res.status === 500 || !res.user) {
                setShowModal(true);
                return;
            }
            if (res.quotationStatus !== "DRAFT") {
                setQuotationDetail(res);
                const activePaymentMethod = res.user?.individualDetail?.paymentMethod?.find(method => method.isActive === true);
                if (activePaymentMethod) {
                    handleSelectedPaymentMethod(activePaymentMethod._id);
                }
            } else {
                console.log("QUOTATION NOT FOUND");
            }
        } catch (error) {
            console.log(error);
        } finally {
            setIsLoading(false);
        }
    };

    const callbackFlywireAuthenticatedUser = async (result, ref) => {
        result.ref = ref;
        if (result.status === "success") {
            const resFinishPayment = await finishPayment({
                ...result,
                id: quotationDetail._id,
                flywireStatus: "UNREGISTERED",
                paymentMethodId: selectedPaymentMethod,
            });

            if (
                resFinishPayment.code === 200 &&
                resFinishPayment.status === "SUCCESS"
            ) {
                history.push(`/PaymentSuccess/${resFinishPayment.data.quotationId}?type=quotation`);
            }
        }
    };

    const extractFirstAndLastName = async (fullName) => {
        // Split the full name into an array of strings
        const nameParts = fullName.trim().split(" ");

        // Extract the first name (first element of the array)
        const firstName = nameParts[0];

        // Extract the last name (last element of the array, if exists)
        const lastName =
            nameParts.length > 1 ? nameParts[nameParts.length - 1] : "";

        // Return an object containing the first name and last name
        return {
            firstName: firstName,
            lastName: lastName ? lastName : firstName,
        };
    };

    const payButtonAuthenticatedUser = async () => {
        var resFinishPayment = await finishPayment({
            id: quotationId,
            flywireStatus: "REGISTERED",
            paymentMethodId: selectedPaymentMethod
        });

        if (resFinishPayment.status === "SUCCESS") {
            history.push(`/PaymentSuccess/${resFinishPayment.data.quotationId}?type=quotation`);
        } else {
            console.log("resFinishPayment.status = FAILED");
        }

    }

    const payButtonHandle = async (user) => {
        var resGetDetails = await getDetails(quotationId);
        setQuotationDetail(resGetDetails);
        handleSelectedPaymentMethod(resGetDetails?.user?.individualDetail?.paymentMethod?.find(method => method.isActive === true)?._id);

        var res = await paymentEligibility(quotationId);

        if (res.status === "ELIGIBLE") {
            if (res.flywireStatus === "REGISTERED") {
                handleCloseClientInfoModal();
                handleModalSelectPaymentMethod(true);
            } else {
                if (
                    !user ||
                    !user.role
                ) {
                    console.log("User info not ready.");
                    return;
                }

                // Resolve correct detail object
                const accountDetail =
                    user[
                    user.role === "individual"
                        ? "individualDetail"
                        : "businessDetail"
                    ];

                // Validate accountDetail
                if (
                    !accountDetail ||
                    !accountDetail.billingInformation
                ) {
                    console.log("Billing information not ready.");
                    return;
                }

                // Extract billing info fields
                const { billingInformation } = accountDetail;

                // Safely load env (prevent split error on first render)
                const countryWithoutPostCode = process.env.REACT_APP_COUNTRY_WITHOUT_POSTCODE || "";
                const isCountryWithoutPostCode = countryWithoutPostCode
                    .split(",")
                    .includes(billingInformation.country_code);

                if (!billingInformation.country_code) {
                    console.log("Country code missing.");
                    return;
                }

                // Postal code is only required for countries that use one
                if (!isCountryWithoutPostCode && !billingInformation.postal_code) {
                    console.log("Postal code missing.");
                    return;
                }

                // Prepare city
                let city = null;

                if (isCountryWithoutPostCode) {
                    // No postal code for these countries — use the billing city directly
                    city = billingInformation.city;
                } else {
                    // Fetch location from postal code
                    const zipCodeCheck = await getLocationByAddress(
                        billingInformation.postal_code,
                        billingInformation.country_code
                    );

                    // If invalid, block process
                    if (!zipCodeCheck) {
                        console.log("INVALID ZIP CODE (Google API returned empty)");
                        return;
                    }

                    const hasAddressComponents =
                        Array.isArray(zipCodeCheck.address_components) &&
                        zipCodeCheck.address_components.length > 0;

                    if (hasAddressComponents) {
                        const cityComponent = zipCodeCheck.address_components.find(
                            (item) =>
                                item.types.includes("administrative_area_level_2") ||
                                item.types.includes("locality")
                        );

                        if (cityComponent) {
                            city = cityComponent.long_name;
                        } else {
                            const lastIndex = zipCodeCheck.address_components.length - 2;
                            city =
                                lastIndex >= 0
                                    ? zipCodeCheck.address_components[lastIndex].long_name
                                    : null;
                        }
                    }
                }

                // Extract name
                const { firstName, lastName } = await extractFirstAndLastName(
                    billingInformation.name
                );

                // Flywire config
                const config = {
                    env: process.env.REACT_APP_FLYWIRE_ENV,
                    recipientCode: process.env.REACT_APP_FLYWIRE_TLF_RECIPIENT_CODE,

                    amount: 0,
                    recurringType: "tokenization",
                    recurringTypeRecipientCodes: [
                        process.env.REACT_APP_FLYWIRE_TLF_RECIPIENT_CODE,
                        process.env.REACT_APP_FLYWIRE_JPT_RECIPIENT_CODE
                    ],

                    firstName: firstName,
                    lastName: lastName,
                    email: user?.email,
                    phone: billingInformation.prefix_number + " " + billingInformation.phone,
                    address: billingInformation.address,
                    city: city,
                    zip: billingInformation.postal_code, // FIXED
                    country: billingInformation.country_code,

                    recipientFields: {
                        booking_reference: `QT-${quotationDetail._id}`,
                        additional_information: null
                    },

                    requestPayerInfo: false,
                    requestRecipientInfo: false,

                    paymentOptionsConfig: {
                        filters: {
                            type: ["credit_card"]
                        }
                    },

                    onCompleteCallback: function (args) {
                        callbackFlywireAuthenticatedUser(args, `QT-${quotationDetail._id}`);
                    },

                    onInvalidInput: function (errors) {
                        errors.forEach(function (error) {
                            console.log(error.msg);
                        });
                    }
                };

                handleCloseClientInfoModal();

                const modal = window.FlywirePayment.initiate(config);
                modal.render();
            }
        } else {
            console.log("NOT ELIGIBLE");
        }
    };

    const downloadButtonClickFunc = async () => {
        var res = await getDetails(quotationId);
        if (res.quotationStatus !== "DRAFT") {
            setQuotationDetail(res);

            const blob = await pdf((
                <QuotationDocument data={res} />
            )).toBlob();

            saveAs(blob, `TLF-QUOTATION-${res?.quotationID}.pdf`);

            handleCloseClientInfoModal();
        }
    };

    const toggleOpen = (index) => {
        setOpenItems((prevOpenItems) => {
            if (prevOpenItems.includes(index)) {
                return prevOpenItems.filter((itemIndex) => itemIndex !== index); // Close the item
            } else {
                return [...prevOpenItems, index]; // Open the item
            }
        });
    };

    const getPhoneNumber = (item) => {
        if (item.role === "individual" || item.role === "business") {
            const accountDetail = item[item.role === "individual" ? "individualDetail" : "businessDetail"]
            return accountDetail.billingInformation.phone !== "" ? `(${accountDetail.billingInformation.prefix_number ?? "-"}) ${accountDetail.billingInformation.phone}` : "-";
        }
        return "";
    };

    const handlePrint = async () => {
        var data = [];
        for (let index = 0; index < quotationDetail?.bookings.length; index++) {
            for (
                let index2 = 0;
                index2 < quotationDetail?.bookings[index]?.bookingItems.length;
                index2++
            ) {
                data.push(index + "" + index2);
            }
        }
        setOpenItems(data);
        setShowTNCTables(true);
        // Allow DOM update to complete before printing
        setTimeout(() => {
            window.print();
            setShowTNCTables(false);
        }, 0); // Use a minimal timeout to ensure the UI update finishes
    };

    const handlePrintNew = () => {
        setIsPrint(!isPrint);
    }

    const handleSetNewCard = (newCard) => {
        setQuotationDetail((prev) => ({
            ...prev,
            user: {
                ...prev.user,
                individualDetail: {
                    ...prev.user.individualDetail,
                    paymentMethod: [...prev.user.individualDetail.paymentMethod, newCard],
                },
            },
        }),);
    }

    const handleDeleteCard = (paymentMethodId) => {
        setQuotationDetail((prev) => ({
            ...prev,
            user: {
                ...prev.user,
                individualDetail: {
                    ...prev.user.individualDetail,
                    paymentMethod: prev.user.individualDetail.paymentMethod.filter(
                        (method) => method._id !== paymentMethodId
                    ),
                },
            },
        }));
    };

    const addPaymentMethodHandler = async () => {
        const accountDetail = quotationDetail?.user[quotationDetail?.user?.role === "individual" ? "individualDetail" : "businessDetail"];
        const { firstName, lastName } = await extractFirstAndLastName(accountDetail.name);

        // Postal code is only required for countries that use one; others rely on the billing city directly
        const countryWithoutPostCode = process.env.REACT_APP_COUNTRY_WITHOUT_POSTCODE || "";
        const isCountryWithoutPostCode = countryWithoutPostCode
            .split(",")
            .includes(accountDetail.billingInformation.country_code);

        let city = accountDetail.billingInformation.city;
        if (!isCountryWithoutPostCode) {
            const zipCodeCheck = await getLocationByAddress(accountDetail.billingInformation.postal_code, accountDetail.billingInformation.country_code);
            const cityComponent = zipCodeCheck?.address_components?.find((item) => item.types.includes("administrative_area_level_2") || item.types.includes("locality"));
            city = cityComponent?.long_name ?? city;
        }

        const config = {
            env: process.env.REACT_APP_FLYWIRE_ENV,
            recipientCode: process.env.REACT_APP_FLYWIRE_TLF_RECIPIENT_CODE,

            amount: 0,
            recurringType: "tokenization",
            recurringTypeRecipientCodes: [
                process.env.REACT_APP_FLYWIRE_TLF_RECIPIENT_CODE,
                process.env.REACT_APP_FLYWIRE_JPT_RECIPIENT_CODE,
            ],

            firstName: firstName,
            lastName: lastName,
            email: quotationDetail?.user.email,
            phone: accountDetail.billingInformation.prefix_number + " " + accountDetail.billingInformation.phone,
            address: accountDetail.billingInformation.address,
            city: city,
            zip: accountDetail.billingInformation.postal_code,
            country: accountDetail.billingInformation.country_code,

            requestPayerInfo: false,
            requestRecipientInfo: false,

            // Control which tokenization options are available
            paymentOptionsConfig: {
                filters: {
                    type: ["credit_card"],
                },
            },
            onCompleteCallback: function (args) {
                callbackFlywireAddPaymentMethod(args);
            },
            onInvalidInput: function (errors) {
                errors.forEach(function (error) {
                    console.log(error.msg);
                });
            },
        };

        // setLoading(false);
        const modal = window.FlywirePayment.initiate(config);
        modal.render();
    };

    const callbackFlywireAddPaymentMethod = async (result) => {
        if (result.status === "success") {
            const updatePayment = await flywireAddPaymentMethod(result);

            if (updatePayment.status === "SUCCESS") {
                handleSetNewCard(updatePayment.data);
                handleSelectedPaymentMethod(updatePayment.data._id);
            } else {
                handleModalSelectPaymentMethod(false);
                setmodalAlertText(updatePayment.msg ?? "An error occurred while tokenize credit card.");
                setShowModalAlert(true);
            }
        }
    };

    useEffect(() => {
        const mainButton = mainPayButtonRef.current
        const mobileButton = mobilePayButtonRef.current

        // Create observers
        const mainObserver = new IntersectionObserver(
            ([entry]) => {
                setIsMainButtonVisible(entry.isIntersecting)
            },
            { threshold: 0.1 },
        )

        const mobileObserver = new IntersectionObserver(
            ([entry]) => {
                setIsMobileButtonVisible(entry.isIntersecting)
            },
            { threshold: 0.1 },
        )

        // Start observing if elements exist
        if (mainButton) {
            mainObserver.observe(mainButton)
        }

        if (mobileButton) {
            mobileObserver.observe(mobileButton)
        }

        // Cleanup function
        return () => {
            if (mainButton) {
                mainObserver.unobserve(mainButton)
            }
            if (mobileButton) {
                mobileObserver.unobserve(mobileButton)
            }
        }
    })

    const stickyButtonStyle = {
        position: "fixed",
        bottom: "50px",
        zIndex: 1000,
        display: isMainButtonVisible || isMobileButtonVisible ? "none" : "block",
        transition: "all 0.3s ease",
        animation: isMainButtonVisible || isMobileButtonVisible ? "none" : "fadeIn 1s ease-in-out",
        // width: "250px",  // Set a specific width

        // marginLeft: "1000px",

        // Mobile-specific adjustments
        "@media (maxWidth: 768px)": {
            bottom: "15px",
            right: "15px",
            // width: "90%",  // Slightly narrower for mobile
        },
    }

    // From the customer's perspective the payment step is done for anything past
    // NOT_PAID: READY_TO_CHARGE / CHARGE_INITIATED / CHARGED (new flow, charged by
    // admin later) or legacy PAID (old data).
    const isCustomerPaid = ["PAID", "READY_TO_CHARGE", "CHARGE_INITIATED", "CHARGED", "CHARGE_FAILED"]
        .includes(quotationDetail?.paymentStatus)

    const eligibilityPayButton = (detail) => {
        let eligibilityStatus = true;

        detail?.bookings?.map((v) => {
            if (!v.pickupLocation || v.destinations.length === 0) eligibilityStatus = false
        })

        if (detail?.quotationStatus !== "ACTIVE") eligibilityStatus = false

        if (detail?.paymentStatus !== "NOT_PAID") eligibilityStatus = false

        return eligibilityStatus;
    }

    const getBookingType = (bookingType, isAirportTransfer) => {
        switch (bookingType) {
            case "byTheHour":
                return "byTheHour"
            case "specifiedDestination":
                if (isAirportTransfer) {
                    return "airportTransfer"
                } else {
                    return "specifiedDestination"
                }
            default:
                return "";
        }
    }

    if (error) {
        return <PageNotFound />;
    }

    return (
        <>
            <AlertModal
                handleClose={handleCloseModalAlert}
                show={showModalAlert}
                text={modalAlertText}
            />
            <Fragment>
                <div className="bg-grey-light tw:!font-hanken-grotesk">
                    <div className="sticky-top no-print" style={{ zIndex: 1030 }}>
                        <div className="px-1 px-md-5 py-2 bg-dark position-relative">
                            <div className="d-flex justify-content-center justify-content-md-start align-items-center">
                                <Link className="py-2 navbar-brand pe-md-4" to="/">
                                    <img
                                        className="image-fluid d-none d-md-block"
                                        src={logo}
                                        alt="logo"
                                    />
                                    <img
                                        className="image-fluid d-block d-md-none"
                                        src={logoMobile}
                                        alt="logo"
                                    />
                                </Link>
                            </div>
                            {/* Desktop: language inside the sticky navbar */}
                            <div className="d-none d-md-block position-absolute top-50 end-0 translate-middle-y pe-md-5">
                                <LanguageCard />
                            </div>
                        </div>
                    </div>
                    {/* Mobile: language always fixed on screen */}
                    <div
                        className="d-block d-md-none no-print"
                        style={{ position: "fixed", top: "10px", right: "10px", zIndex: 1050 }}
                    >
                        <LanguageCard />
                    </div>
                    {isLoading && (
                        <QuotationSkeleton />
                    )}
                    {isShow && !isLoading && (
                        <div className="container-md pt-5 r-mt-5-print pb-5">
                            <div className="d-none d-md-block no-print">
                                <div className="d-flex justify-content-between mb-2 ">
                                    <div className="col no-print">
                                        <div className="d-flex gap-2">
                                            <button className="bg-dark rounded" onClick={handlePrintNew}>
                                                <div className="tw:flex! tw:justify-center! tw:items-center! tw:gap-2! tw:px-4! tw:py-2!">
                                                    {!isPrint && (
                                                        <PrintIcon color="#FFFFFF" />
                                                    )}
                                                    <p className="tw:!font-hanken-grotesk m-0 text-white">{isPrint ? t("Back") : t("Quotation.LinkPage.Print")}</p>
                                                </div>
                                            </button>
                                            <button className="bg-dark rounded" onClick={() => handleOpenClientInfoModal("download")}>
                                                <div className="tw:flex! tw:justify-center! tw:items-center! tw:gap-2! tw:px-4! tw:py-2!">
                                                    <DownloadNarrowIcon color="#FFFFFF" />
                                                    <p className="tw:!font-hanken-grotesk m-0 text-white">{t("Quotation.LinkPage.Download")}</p>
                                                </div>
                                            </button>
                                        </div>
                                    </div>
                                    <div className="col no-print">
                                        <div className="d-flex justify-content-end gap-2">
                                            <div className="col-6">
                                                <div className="d-grid">
                                                    {eligibilityPayButton(quotationDetail) && (
                                                        <button
                                                            className="bg-gold rounded"
                                                            onClick={() => handleOpenClientInfoModal("pay")}
                                                            ref={mainPayButtonRef}
                                                        >
                                                            <div className="tw:flex! tw:justify-center! tw:items-center! tw:gap-2! tw:px-4! tw:py-2!">
                                                                <p className="tw:!font-hanken-grotesk m-0 text-white">{t("Quotation.LinkPage.PayNow")}</p>
                                                                <ArrowRightIcon color="white" size={15} />
                                                            </div>
                                                        </button>
                                                    )}
                                                </div>
                                            </div>
                                            <button
                                                className={`rounded ${isCustomerPaid ? "bg-green text-white"
                                                    : quotationDetail?.quotationStatus === "DRAFT" ? "bg-DADADA"
                                                        : quotationDetail?.quotationStatus === "ACTIVE" && quotationDetail?.paymentStatus === "NOT_PAID" ? "bg-blue text-white"
                                                            : "bg-EA4335 text-white"
                                                    }`}
                                            >
                                                <div className="d-flex gap-2 px-3 py-2 ">
                                                    <p className={`tw:!font-hanken-grotesk m-0 ${quotationDetail?.quotationStatus !== "DRAFT" && 'text-white'}`}>
                                                        {" "}
                                                        {
                                                            isCustomerPaid ? t("Quotation.LinkPage.Status.Paid")
                                                                : quotationDetail?.quotationStatus === "DRAFT" ? t("Quotation.LinkPage.Status.Draft")
                                                                    : quotationDetail?.quotationStatus === "ACTIVE" && quotationDetail?.paymentStatus === "NOT_PAID" ? t("Quotation.LinkPage.Status.Active")
                                                                        : quotationDetail?.quotationStatus === "EXPIRED" ? t("Quotation.LinkPage.Status.Expired")
                                                                            : ""
                                                        }
                                                    </p>
                                                </div>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* MOBILE BUTTONS */}
                            <div className="d-block d-md-none no-print">
                                <div className="row mb-2 ">
                                    <div className="col-12  no-print">
                                        <div className="d-flex gap-2">
                                            <button className="bg-dark rounded" onClick={() => handleOpenClientInfoModal("download")}>
                                                <div className="col tw:flex! tw:justify-center! tw:items-center! tw:gap-2! tw:px-4! tw:py-2!">
                                                    <DownloadNarrowIcon color="#FFFFFF" />
                                                    <p className="tw:!font-hanken-grotesk m-0 text-white">{t("Quotation.LinkPage.Download")}</p>
                                                </div>
                                            </button>
                                            <button
                                                className={`rounded col ${isCustomerPaid ? "bg-green text-white"
                                                    : quotationDetail?.quotationStatus === "DRAFT" ? "bg-DADADA"
                                                        : quotationDetail?.quotationStatus === "ACTIVE" && quotationDetail?.paymentStatus === "NOT_PAID" ? "bg-blue text-white"
                                                            : "bg-EA4335 text-white"
                                                    }`}
                                            >
                                                <div className="d-flex gap-2 px-3 py-2 justify-content-center ">
                                                    <p className={`tw:!font-hanken-grotesk m-0 ${quotationDetail?.quotationStatus !== "DRAFT" && 'text-white'}`}>
                                                        {" "}
                                                        {
                                                            isCustomerPaid ? t("Quotation.LinkPage.Status.Paid")
                                                                : quotationDetail?.quotationStatus === "DRAFT" ? t("Quotation.LinkPage.Status.Draft")
                                                                    : quotationDetail?.quotationStatus === "ACTIVE" && quotationDetail?.paymentStatus === "NOT_PAID" ? t("Quotation.LinkPage.Status.Active")
                                                                        : quotationDetail?.quotationStatus === "EXPIRED" ? t("Quotation.LinkPage.Status.Expired")
                                                                            : ""
                                                        }
                                                    </p>
                                                </div>
                                            </button>
                                        </div>
                                    </div>

                                    <div className="col-12 mt-3  no-print">
                                        <div className="d-flex justify-content-end gap-2">
                                            <div className="col-12  no-print">
                                                <div className="d-grid">
                                                    {eligibilityPayButton(quotationDetail) && (
                                                        <button
                                                            className="bg-gold rounded"
                                                            onClick={() => handleOpenClientInfoModal("pay")}
                                                            ref={mobilePayButtonRef}
                                                        >
                                                            <div className="tw:flex! tw:justify-center! tw:items-center! tw:gap-2! tw:px-4! tw:py-2!">
                                                                <p className="tw:!font-hanken-grotesk m-0 text-white">{t("Quotation.LinkPage.PayNow")}</p>
                                                                <ArrowRightIcon color="white" size={15} />
                                                            </div>
                                                        </button>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {!isPrint ? (
                                <div className="bg-white rounded mb-5">
                                    <div className="p-3">
                                        <div className="d-flex align-items-center justify-content-between">
                                            <h4
                                                className='tw:!m-0 tw:!font-hanken-grotesk'
                                                style={{
                                                    fontSize: "29px",
                                                    fontWeight: "900",
                                                    color: "#212529",
                                                }}
                                            >
                                                {t("Quotation.LinkPage.Quotation")}
                                            </h4>
                                            <img src={tlf_logo_quotation} alt="" srcSet="" />
                                        </div>
                                    </div>
                                    <hr className="m-0 divider" />
                                    <div className="p-3 mb-3">
                                        <div className="row m-0">
                                            <div className="col-md-4">
                                                <p className="tw:!font-hanken-grotesk m-0 w-700 fs-12 text-A7A7A7">{t("Quotation.LinkPage.To.English")}</p>
                                                <p
                                                    className="tw:!font-hanken-grotesk m-0 w-700 fs-16 text-4E4E4E"
                                                    style={{ fontWeight: "700 !important" }}
                                                >
                                                    {quotationDetail?.user.name} {" "} {t("Quotation.LinkPage.To.Japanese")}
                                                </p>
                                                <p className="tw:!font-hanken-grotesk text-gold text-decoration-underline">
                                                    {quotationDetail?.user.email}
                                                </p>
                                                <p className="tw:!font-hanken-grotesk">
                                                    {quotationDetail?.user.role === "individual"
                                                        ? quotationDetail?.user?.individualDetail
                                                            ?.billingInformation?.address
                                                        : quotationDetail?.user?.businessDetail
                                                            ?.billingInformation?.address}
                                                </p>
                                                <p className="tw:!font-hanken-grotesk">
                                                    {" "}
                                                    {quotationDetail?.user &&
                                                        getPhoneNumber(quotationDetail?.user)}
                                                </p>
                                            </div>
                                            <div className="col-md-5">
                                                <p className="tw:!font-hanken-grotesk m-0 w-700 fs-12 text-A7A7A7">{t("Quotation.LinkPage.From")}</p>
                                                <p
                                                    className="tw:!font-hanken-grotesk m-0 w-700 fs-16 text-4E4E4E"
                                                    style={{ fontWeight: "700 !important" }}
                                                >
                                                    {t("Quotation.LinkPage.CompanyDetail.Name")}
                                                </p>
                                                <p className="tw:!font-hanken-grotesk text-gold text-decoration-underline">
                                                    {t("Quotation.LinkPage.CompanyDetail.Email")}
                                                </p>
                                                <p className="tw:!font-hanken-grotesk">
                                                    {t("Quotation.LinkPage.CompanyDetail.Address")}
                                                </p>
                                                <p className="tw:!font-hanken-grotesk">{t("Quotation.LinkPage.CompanyDetail.Telp")}</p>
                                            </div>
                                            <div className="col-md-3">
                                                <div className="d-flex ">
                                                    <table>
                                                        <tr>
                                                            <td className="pb-0">
                                                                <p className="tw:!font-hanken-grotesk p-0 m-0 text-7C7B7B fw-400 fs-14 text-nowrap">
                                                                    {t("Quotation.LinkPage.IssueDate")}
                                                                </p>
                                                            </td>
                                                            <td className="pb-0">
                                                                <p className="tw:!font-hanken-grotesk ms-3 mb-0 text-4E4E4E fw-400 fs-14 text-nowrap fw-400">
                                                                    {" "}
                                                                    {quotationDetail &&
                                                                        moment(quotationDetail?.issueDate).format(
                                                                            formatMomentDate[lang]
                                                                        )}
                                                                </p>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td className="pb-0">
                                                                <p className="tw:!font-hanken-grotesk p-0 m-0 text-7C7B7B fw-400 fs-14 text-nowrap">
                                                                    {t("Quotation.LinkPage.QuotationNumber")}
                                                                </p>
                                                            </td>
                                                            <td className="pb-0">
                                                                <p className="tw:!font-hanken-grotesk ms-3 mb-0 text-4E4E4E fw-400 fs-14 text-nowrap  fw-400">
                                                                    {" "}
                                                                    {quotationDetail?.quotationID}
                                                                </p>
                                                            </td>
                                                        </tr>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="row m-0 mt-3 mt-md-0">
                                            <div className="col-md-4">
                                                <table className="w-100 border-282828">
                                                    <tr className="border-282828">
                                                        <td rowSpan={2} className="text-center border-282828">
                                                            <p className="tw:!font-hanken-grotesk mb-2 fs-14 fw-400">{t("Quotation.LinkPage.ValidUntil")}</p>
                                                            <p className="tw:!font-hanken-grotesk mb-0 fs-14 fw-700 text-282828">
                                                                {quotationDetail &&
                                                                    moment(quotationDetail?.expiredDate).format(
                                                                        formatMomentDate[lang]
                                                                    )}
                                                            </p>
                                                        </td>
                                                        <td className="text-center border-282828 bg-dark">
                                                            <p className="tw:!font-hanken-grotesk m-0 text-white fw-700 fs-14">{t("Quotation.LinkPage.Total")}</p>
                                                        </td>
                                                    </tr>
                                                    <tr className="border-282828">
                                                        <td className="text-center border-282828">
                                                            <p className="tw:!font-hanken-grotesk m-0 text-282828 fw-700 fs-20">
                                                                {`${computeQuotationTotalAmount(quotationDetail).toLocaleString()}${t("Quotation.LinkPage.JPY")}`}
                                                            </p>
                                                        </td>
                                                    </tr>
                                                </table>
                                            </div>
                                        </div>
                                    </div>

                                    {/* DESKTOP VIEW */}
                                    <div className=" d-none d-md-block">
                                        <table className="table table-quotation-items mb-3">
                                            <tr className="bg-dark">
                                                <th className="align-middle py-2" style={{ width: "2%", whiteSpace: "nowrap" }}>
                                                    <p className="tw:!font-hanken-grotesk py-0 ms-2 text-white mb-0">{t("Quotation.LinkPage.Table.ServiceDate")}</p>
                                                </th>
                                                <th className="align-middle py-2" style={{ width: "10%", whiteSpace: "nowrap" }}>
                                                    <b className="tw:!font-hanken-grotesk pb-0 ms-2">{t("Quotation.LinkPage.Table.Name")}</b>
                                                    <p className="tw:!font-hanken-grotesk py-0 ms-2 mb-0 text-white">{t("Quotation.LinkPage.Table.Description")}</p>
                                                </th>
                                                <th className="align-middle py-2" style={{ width: "1%", whiteSpace: "nowrap" }}>
                                                    <p className="tw:!font-hanken-grotesk py-0 ms-2 text-white mb-0">{t("Quotation.LinkPage.Table.UnitPrice")}</p>
                                                </th>
                                                <th className="align-middle py-2" style={{ width: "1%", whiteSpace: "nowrap" }}>
                                                    <p className="tw:!font-hanken-grotesk py-0 ms-2 text-white mb-0">{t("Quotation.LinkPage.Table.Qty")}</p>
                                                </th>
                                                <th className="align-middle py-2" style={{ width: "1%", whiteSpace: "nowrap" }}>
                                                    <p className="tw:!font-hanken-grotesk py-0 ms-2 text-white mb-0">{t("Quotation.LinkPage.Table.Amount")}</p>
                                                </th>
                                            </tr>

                                            <>
                                                {quotationDetail?.bookings.map((item, index) => (
                                                    <>
                                                        {/* Booking Type Row */}
                                                        <tr className="bg-7C7B7B">
                                                            <td colSpan={5}>
                                                                <p className="tw:!font-hanken-grotesk m-0 tw:!text-[#FFFFFF] tw:!text-[14px] tw:!font-[400]">
                                                                    {t(`BookingType.${getBookingType(item?.bookingType, item?.isAirportTransfer)}`)}
                                                                </p>
                                                            </td>
                                                        </tr>

                                                        {/* Booking Items */}
                                                        {item?.bookingItems.map((b, index) => (
                                                            <>
                                                                <tr
                                                                    key={index}
                                                                    className={`${index !== 0 ? 'border-top' : ''}`}
                                                                >
                                                                    <td>
                                                                        <p className="tw:!font-hanken-grotesk py-0 mb-0 tw:!text-[#4E4E4E] tw:!text-[14px]">
                                                                            {
                                                                                lang?.toUpperCase() === "JP" ? b?.serviceDateJP || b?.serviceDate : b?.serviceDate
                                                                            }
                                                                        </p>
                                                                    </td>
                                                                    <td>
                                                                        <p className="tw:!font-hanken-grotesk tw:!text-[#4E4E4E] tw:!font-[700] tw:!text-[14px] tw:!py-0 tw:!mb-0" style={{ fontFamily: "'Hanken Grotesk', sans-serif" }}>
                                                                            {
                                                                                lang?.toUpperCase() === "JP" ? b?.nameJP || b?.name : b?.name
                                                                            }
                                                                        </p>
                                                                        <p className="tw:!font-hanken-grotesk tw:!text-[#4E4E4E] tw:!font-[400] tw:!text-[14px] tw:!py-0 tw:!mb-0" style={{ fontFamily: "'Hanken Grotesk', sans-serif" }}>
                                                                            {
                                                                                lang?.toUpperCase() === "JP" ? b?.descJP || b?.desc : b?.desc
                                                                            }
                                                                        </p>
                                                                    </td>
                                                                    <td className="tw:!text-[#4E4E4E] tw:!font-[400] tw:!text-[14px]">{`${b?.price?.toLocaleString()}${t("Quotation.LinkPage.JPY")}`}</td>
                                                                    <td className="tw:!text-[#4E4E4E] tw:!font-[400] tw:!text-[14px]">{b?.qty}</td>
                                                                    <td className="tw:!text-[#4E4E4E] tw:!font-[400] tw:!text-[14px]">{`${b?.totalPrice?.toLocaleString()}${t("Quotation.LinkPage.JPY")}`}</td>
                                                                </tr>

                                                                {b.type === "vehicle" && (
                                                                    [...Array(bookingItemsDetailOrder.length)].map((x, i) => (
                                                                        item.useDiscount ? (
                                                                            bookingItemsDetailOrder[i] === "discount" ? (
                                                                                <tr className="bg-F5F5F5">
                                                                                    <td colSpan={4}>
                                                                                        <p className="tw:!font-hanken-grotesk px-0 py-0 mb-0 text-description text-end">{`${t("Quotation.LinkPage.Table.Discount")} (${b?.discount}%)`}</p>
                                                                                    </td>
                                                                                    <td className="text-description py-0 my-0">
                                                                                        {b?.totalDiscount ? `-${b?.totalDiscount.toLocaleString()}${t("Quotation.LinkPage.JPY")}` : `0${t("Quotation.LinkPage.JPY")}`}
                                                                                    </td>
                                                                                </tr>
                                                                            ) : (
                                                                                b?.details?.find(item => item.id === bookingItemsDetailOrder[i])?.amount > 0 && (
                                                                                    <tr
                                                                                        key={i}
                                                                                        className={`border-top-dashed`}
                                                                                    >
                                                                                        <td></td>
                                                                                        <td><p className="tw:!font-hanken-grotesk px-4 py-0 mb-0 text-description tw:!text-[#4E4E4E]">{b?.details?.find(item => item.id === bookingItemsDetailOrder[i]).id && b?.details?.find(item => item.id === bookingItemsDetailOrder[i]).id === "lateNightFee" ? t(`Quotation.LinkPage.Table.${b?.details?.find(item => item.id === bookingItemsDetailOrder[i]).id}`, { hour: b?.details?.find(item => item.id === bookingItemsDetailOrder[i]).nightHours || 0 }) : b?.details?.find(item => item.id === bookingItemsDetailOrder[i]).id ? t(`Quotation.LinkPage.Table.${b?.details?.find(item => item.id === bookingItemsDetailOrder[i]).id}`) : b?.details?.find(item => item.id === bookingItemsDetailOrder[i]).name}</p></td>
                                                                                        <td></td>
                                                                                        <td></td>
                                                                                        <td className="text-description tw:!text-[#4E4E4E]">{`${b?.details?.find(item => item.id === bookingItemsDetailOrder[i]).amount?.toLocaleString()}${t("Quotation.LinkPage.JPY")}`}</td>
                                                                                    </tr>
                                                                                )
                                                                            )
                                                                        ) : (
                                                                            (bookingItemsDetailOrder[i] !== "discount" && b?.details?.find(item => item.id === bookingItemsDetailOrder[i])?.amount > 0) && (
                                                                                <tr
                                                                                    key={i}
                                                                                    className={`border-top-dashed`}
                                                                                >
                                                                                    <td></td>
                                                                                    <td><p className="tw:!font-hanken-grotesk px-4 py-0 mb-0 text-description tw:!text-[#4E4E4E]">{b?.details?.find(item => item.id === bookingItemsDetailOrder[i]).id && b?.details?.find(item => item.id === bookingItemsDetailOrder[i]).id === "lateNightFee" ? t(`Quotation.LinkPage.Table.${b?.details?.find(item => item.id === bookingItemsDetailOrder[i]).id}`, { hour: b?.details?.find(item => item.id === bookingItemsDetailOrder[i]).nightHours || 0 }) : b?.details?.find(item => item.id === bookingItemsDetailOrder[i]).id ? t(`Quotation.LinkPage.Table.${b?.details?.find(item => item.id === bookingItemsDetailOrder[i]).id}`) : b?.details?.find(item => item.id === bookingItemsDetailOrder[i]).name}</p></td>
                                                                                    <td></td>
                                                                                    <td></td>
                                                                                    <td className="text-description tw:!text-[#4E4E4E]">{`${b?.details?.find(item => item.id === bookingItemsDetailOrder[i])?.amount?.toLocaleString()}${t("Quotation.LinkPage.JPY")}`}</td>
                                                                                </tr>
                                                                            )
                                                                        )
                                                                    ))
                                                                )}
                                                            </>
                                                        ))}

                                                        {getAdditionalGroups(item).map((group, groupIndex) => (
                                                            <Fragment key={`group-${groupIndex}`}>
                                                                {group.heading && (
                                                                    <tr className={`border-top tw:!bg-[#F1F1F1]`}>
                                                                        <td colSpan={5}>
                                                                            <p className="tw:!font-hanken-grotesk m-0 py-0 tw:!text-[#212529]">{group.heading}</p>
                                                                        </td>
                                                                    </tr>
                                                                )}
                                                                {(group.items || []).map((additionalItem, additionalIndex) => {
                                                                    const itemName = additionalItem?.name || "-";
                                                                    const additionalItemServiceDate = additionalItem?.serviceDate ? moment(additionalItem.serviceDate).format(formatMomentDate[lang]) : "";
                                                                    const isFirstRow = !group.heading && additionalIndex === 0;
                                                                    return (
                                                                        <tr className={isFirstRow ? "border-top" : "border-top-dashed"} key={`additional-${groupIndex}-${additionalIndex}`}>
                                                                            <td><p className="tw:!font-hanken-grotesk py-0 mb-0 tw:!text-[#4E4E4E] tw:!font-[400] tw:!text-[14px]">{additionalItemServiceDate}</p></td>
                                                                            <td><p className="tw:!font-hanken-grotesk py-0 mb-0 tw:!text-[#4E4E4E] tw:!font-[400] tw:!text-[14px]">{itemName}</p></td>
                                                                            <td className="tw:!text-[#4E4E4E] tw:!font-[400] tw:!text-[14px]">{`${Number(additionalItem?.price || 0).toLocaleString()}${t("Quotation.LinkPage.JPY")}`}</td>
                                                                            <td className="tw:!text-[#4E4E4E] tw:!font-[400] tw:!text-[14px]">{additionalItem?.qty || ""}</td>
                                                                            <td style={{ whiteSpace: "nowrap", width: "1%" }}>
                                                                                <div className="d-flex align-items-center justify-content-start p-0">
                                                                                    <span className="tw:!text-[#4E4E4E] tw:!font-[400] tw:!text-[14px]">{`${Number(additionalItem?.totalPrice || 0).toLocaleString()}${t("Quotation.LinkPage.JPY")}`}</span>
                                                                                </div>
                                                                            </td>
                                                                        </tr>
                                                                    );
                                                                })}
                                                            </Fragment>
                                                        ))}

                                                        {/* Subtotal */}
                                                        <tr className="bg-DADADA">
                                                            <td colSpan={4}>
                                                                <div className="d-flex justify-content-end align-items-center p-0">
                                                                    <span>{t("Quotation.LinkPage.Table.Subtotal")}</span>
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div className="d-flex justify-content-start align-items-center p-0">
                                                                    <b className="tw:!font-hanken-grotesk m-0 p-0 text-nowrap">
                                                                        {item?.bookingItems
                                                                            ? `${(
                                                                                (item?.bookingItems || []).reduce(
                                                                                    (subtotal, b) => subtotal + (b.discountedPrice ? b.discountedPrice : b.totalPrice),
                                                                                    0
                                                                                ) +
                                                                                getAllAdditionalItems(item).reduce(
                                                                                    (subtotal, additionalItem) => subtotal + Number(additionalItem?.totalPrice || 0),
                                                                                    0
                                                                                )
                                                                            ).toLocaleString()}${t("Quotation.LinkPage.JPY")}`
                                                                            : `0${t("Quotation.LinkPage.JPY")}`}
                                                                    </b>
                                                                </div>
                                                            </td>
                                                        </tr>

                                                        {
                                                            item?.message?.length > 0 && (
                                                                <tr className="bg-gold-grey-F9F9F9 border border-bottom">
                                                                    <td className="m-2 d-flex justify-content-start align-items-start">
                                                                        <p className="tw:!font-hanken-grotesk py-0 px-0 mb-0 tw:!text-[14px]">
                                                                            {t("Quotation.LinkPage.TransferNotes")}
                                                                        </p>
                                                                    </td>
                                                                    <td colSpan={4} className="">
                                                                        {item?.message ? (
                                                                            item.message.map((m) => <p className="tw:!font-hanken-grotesk m-0 tw:!text-[14px]">{m.note}</p>)
                                                                        ) : (
                                                                            <p className="tw:!font-hanken-grotesk m-0 tw:!text-[14px]">-</p>
                                                                        )}
                                                                    </td>
                                                                </tr>
                                                            )
                                                        }
                                                    </>
                                                ))}

                                                {/* Standalone Additional Items (desktop) */}
                                                {quotationDetail?.standaloneItemsGroups?.length > 0 && (
                                                    <>
                                                        <tr className="bg-7C7B7B">
                                                            <td colSpan={5}>
                                                                <p className="tw:!font-hanken-grotesk m-0 tw:!text-[#FFFFFF] tw:!text-[14px] tw:!font-[400]">
                                                                    {t("Quotation.LinkPage.AdditionalItems") || "Additional Items"}
                                                                </p>
                                                            </td>
                                                        </tr>
                                                        {quotationDetail.standaloneItemsGroups.map((group, groupIndex) => (
                                                            <Fragment key={`standalone-group-${groupIndex}`}>
                                                                {group.heading && (
                                                                    <tr className={`border-top tw:!bg-[#F1F1F1]`}>
                                                                        <td colSpan={5}>
                                                                            <p className="tw:!font-hanken-grotesk m-0 py-0 tw:!text-[#212529]">{group.heading}</p>
                                                                        </td>
                                                                    </tr>
                                                                )}
                                                                {(group.items || []).map((additionalItem, additionalIndex) => {
                                                                    const itemName = additionalItem?.name || "-";
                                                                    const itemServiceDate = additionalItem?.serviceDate ? moment(additionalItem.serviceDate).format(formatMomentDate[lang]) : "";
                                                                    const isFirstRow = !group.heading && additionalIndex === 0;
                                                                    return (
                                                                        <tr className={isFirstRow ? "border-top" : "border-top-dashed"} key={`standalone-${groupIndex}-${additionalIndex}`}>
                                                                            <td><p className="tw:!font-hanken-grotesk py-0 mb-0 tw:!text-[#4E4E4E] tw:!font-[400] tw:!text-[14px]">{itemServiceDate}</p></td>
                                                                            <td><p className="tw:!font-hanken-grotesk py-0 mb-0 tw:!text-[#4E4E4E] tw:!font-[400] tw:!text-[14px]">{itemName}</p></td>
                                                                            <td className="tw:!text-[#4E4E4E] tw:!font-[400] tw:!text-[14px]">{`${Number(additionalItem?.price || 0).toLocaleString()}${t("Quotation.LinkPage.JPY")}`}</td>
                                                                            <td className="tw:!text-[#4E4E4E] tw:!font-[400] tw:!text-[14px]">{additionalItem?.qty || ""}</td>
                                                                            <td style={{ whiteSpace: "nowrap", width: "1%" }}>
                                                                                <span className="tw:!text-[#4E4E4E] tw:!font-[400] tw:!text-[14px]">{`${Number(additionalItem?.totalPrice || 0).toLocaleString()}${t("Quotation.LinkPage.JPY")}`}</span>
                                                                            </td>
                                                                        </tr>
                                                                    );
                                                                })}
                                                            </Fragment>
                                                        ))}
                                                        <tr className="bg-DADADA">
                                                            <td colSpan={4}>
                                                                <div className="d-flex justify-content-end align-items-center p-0">
                                                                    <span>{t("Quotation.LinkPage.Table.Subtotal")}</span>
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div className="d-flex justify-content-start align-items-center p-0">
                                                                    <b className="tw:!font-hanken-grotesk m-0 p-0 text-nowrap">
                                                                        {`${computeStandaloneItemsTotal(quotationDetail.standaloneItemsGroups).toLocaleString()}${t("Quotation.LinkPage.JPY")}`}
                                                                    </b>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    </>
                                                )}

                                                {/* Total */}
                                                <tr className="bg-dark text-white">
                                                    <td colSpan={4} >
                                                        <div className="d-flex justify-content-end align-items-center p-0">
                                                            <p className="tw:!font-hanken-grotesk py-0 my-0 text-white fs-12">
                                                                <b className="tw:!font-hanken-grotesk fs-16">{t("Quotation.LinkPage.Table.Total")}</b> {" "}
                                                                {t("Quotation.LinkPage.Table.TaxInclude")}
                                                            </p>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="d-flex justify-content-start align-items-center p-0">
                                                            <b className="tw:!font-hanken-grotesk m-0 p-0 fs-18 text-nowrap">
                                                                {`${computeQuotationTotalAmount(quotationDetail).toLocaleString()}${t("Quotation.LinkPage.JPY")}`}
                                                            </b>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </>
                                        </table>
                                    </div>

                                    {/* MOBILE VIEW */}
                                    <div className="d-block d-md-none">
                                        <div className="d-flex bg-dark justify-content-between align-items-center p-3">
                                            <div className="">
                                                <b className="tw:!font-hanken-grotesk pb-0  text-white">{t("Quotation.LinkPage.Table.Name")}</b>
                                                <p className="tw:!font-hanken-grotesk py-0  mb-0 text-white">{t("Quotation.LinkPage.Table.Description")}</p>
                                            </div>
                                            <p className="tw:!font-hanken-grotesk mb-0 text-white">{t("Quotation.LinkPage.Table.Amount")}</p>
                                        </div>
                                        {quotationDetail?.bookings.map((item, index) => (
                                            <>
                                                <div className="bg-7C7B7B p-3">
                                                    <p className="tw:!font-hanken-grotesk m-0 text-white">
                                                        {t(`BookingType.${getBookingType(item?.bookingType, item?.isAirportTransfer)}`)}
                                                    </p>
                                                </div>
                                                {item?.bookingItems.map((b, bIndex) => {
                                                    return (
                                                        <div className="p-3 border-bottom">
                                                            <div className="d-flex justify-content-between align-items-center">
                                                                <div className="">
                                                                    <b className="tw:!font-hanken-grotesk">
                                                                        {
                                                                            lang?.toUpperCase() === "JP" ? b?.nameJP || b?.name : b?.name
                                                                        }
                                                                    </b>
                                                                    <p className="tw:!font-hanken-grotesk py-0 mb-0">
                                                                        {
                                                                            lang?.toUpperCase() === "JP" ? b?.descJP || b?.desc : b?.desc
                                                                        }
                                                                    </p>
                                                                </div>
                                                                {!openItems.includes(index + "" + bIndex) && (
                                                                    <p className="tw:!font-hanken-grotesk m-0 p-0 text-nowrap">
                                                                        {`${item.totalPrice.toLocaleString()}${t("Quotation.LinkPage.JPY")}`}
                                                                    </p>
                                                                )}
                                                            </div>
                                                            <div
                                                                style={{
                                                                    display: "grid",
                                                                    gridTemplateRows: openItems.includes(index + "" + bIndex) ? "1fr" : "0fr",
                                                                    transition: "grid-template-rows 0.3s ease",
                                                                }}
                                                            >
                                                                <div style={{ overflow: "hidden", minHeight: 0 }}>
                                                                    <div className="border-top mt-2">
                                                                        <div className="py-2">
                                                                            <div className="d-flex justify-content-between">
                                                                                <p className="tw:!font-hanken-grotesk m-0 fs-13">{t("Quotation.LinkPage.Table.ServiceDate")}</p>
                                                                                <p className="tw:!font-hanken-grotesk m-0 fs-13">
                                                                                    {
                                                                                        lang?.toUpperCase() === "JP" ? b?.serviceDateJP || b?.serviceDate : b?.serviceDate
                                                                                    }
                                                                                </p>
                                                                            </div>
                                                                            <div className="d-flex justify-content-between mt-2">
                                                                                <p className="tw:!font-hanken-grotesk m-0 fs-13">{t("Quotation.LinkPage.Table.UnitPrice")}</p>
                                                                                <p className="tw:!font-hanken-grotesk m-0 fs-13">
                                                                                    {`${b.price.toLocaleString()}${t("Quotation.LinkPage.JPY")}`}
                                                                                </p>
                                                                            </div>
                                                                            <div className="d-flex justify-content-between mt-2">
                                                                                <p className="tw:!font-hanken-grotesk m-0 fs-13">{t("Quotation.LinkPage.Table.Qty")}</p>
                                                                                <p className="tw:!font-hanken-grotesk m-0 fs-13">{b.qty}</p>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    {
                                                                        b?.type === "vehicle" && (
                                                                            <div className="border-top">
                                                                                <div className="py-2">
                                                                                    {
                                                                                        b?.details?.map((v, i) => (
                                                                                            v?.amount > 0 && (
                                                                                                <div className={`d-flex justify-content-between ${i > 0 && "mt-2"}`}>
                                                                                                    <p className="tw:!font-hanken-grotesk m-0 fs-13">{v?.id && v?.id === "lateNightFee" ? t(`Quotation.LinkPage.Table.${v?.id}`, { hour: v?.nightHours || 0 }) : v?.id ? t(`Quotation.LinkPage.Table.${v?.id}`) : v?.name}</p>
                                                                                                    <p className="tw:!font-hanken-grotesk m-0 fs-13">
                                                                                                        {`${v?.amount?.toLocaleString()}${t("Quotation.LinkPage.JPY")}`}
                                                                                                    </p>
                                                                                                </div>
                                                                                            )
                                                                                        ))
                                                                                    }
                                                                                </div>
                                                                            </div>
                                                                        )
                                                                    }
                                                                    <div className="mt-2 border-top">
                                                                        <div className="py-2">
                                                                            <div className="d-flex justify-content-between">
                                                                                <b className="tw:!font-hanken-grotesk">{t("Quotation.LinkPage.Table.Amount")}</b>
                                                                                <b className="tw:!font-hanken-grotesk">{`${(
                                                                                    b.price * b.qty
                                                                                ).toLocaleString()}${t("Quotation.LinkPage.JPY")}`}</b>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    {
                                                                        b.type === "vehicle" && item.useDiscount && (
                                                                            <div className="mt-2 border-top">
                                                                                <div className="py-2">
                                                                                    <div className="d-flex justify-content-between">
                                                                                        <p className="tw:!font-hanken-grotesk m-0 fs-13">{`${t("Quotation.LinkPage.Table.Discount")} (${b?.discount}%)`}</p>
                                                                                        <p className="tw:!font-hanken-grotesk m-0 fs-13">
                                                                                            {b?.totalDiscount ? `-${b?.totalDiscount?.toLocaleString()}${t("Quotation.LinkPage.JPY")}` : `0${t("Quotation.LinkPage.JPY")}`}
                                                                                        </p>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        )
                                                                    }
                                                                </div>
                                                            </div>
                                                            <div className="tw:flex! tw:justify-center! tw:items-center! text-center">
                                                                <CollapseDownIcon
                                                                    onClick={() => toggleOpen(index + "" + bIndex)}
                                                                    style={{
                                                                        cursor: "pointer",
                                                                        transition: "transform 0.3s ease",
                                                                        transform: openItems.includes(index + "" + bIndex) ? "rotate(180deg)" : "rotate(0deg)",
                                                                    }}
                                                                />
                                                            </div>
                                                        </div>
                                                    );
                                                })}
                                                {getAdditionalGroups(item).map((group, groupIndex) => (
                                                    <div className="p-3 border-bottom" key={`mobile-group-${groupIndex}`}>
                                                        {group.heading && (
                                                            <div className="d-flex justify-content-between align-items-center">
                                                                <b className="tw:!font-hanken-grotesk">{group.heading}</b>
                                                            </div>
                                                        )}
                                                        {group.heading ? (
                                                            <>
                                                                <div
                                                                    style={{
                                                                        display: "grid",
                                                                        gridTemplateRows: openItems.includes(`additional-${index}-${groupIndex}`) ? "1fr" : "0fr",
                                                                        transition: "grid-template-rows 0.3s ease",
                                                                    }}
                                                                >
                                                                    <div style={{ overflow: "hidden", minHeight: 0 }}>
                                                                        <div className="border-top mt-2">
                                                                            {(group.items || []).map((additionalItem, additionalIndex) => {
                                                                                const itemName = additionalItem?.name || "-";
                                                                                const additionalItemServiceDate = additionalItem?.serviceDate ? moment(additionalItem.serviceDate).locale("en").format("MMMM DD, YYYY") : "-";
                                                                                return (
                                                                                    <div key={additionalIndex} className={`d-flex justify-content-between align-items-start ${additionalIndex > 0 ? "mt-2" : "pt-2"}`}>
                                                                                        <div>
                                                                                            <p className="tw:!font-hanken-grotesk py-0 mb-0 text-description">{itemName}</p>
                                                                                            <p className="tw:!font-hanken-grotesk py-0 mb-0 fs-13 text-7C7B7B">{additionalItemServiceDate}</p>
                                                                                            <p className="tw:!font-hanken-grotesk py-0 mb-0 fs-13 text-7C7B7B">{`${t("Quotation.LinkPage.Table.Qty")}: ${additionalItem?.qty}`}</p>
                                                                                        </div>
                                                                                        <p className="tw:!font-hanken-grotesk m-0 p-0 text-nowrap text-description">{`${additionalItem?.totalPrice?.toLocaleString()}${t("Quotation.LinkPage.JPY")}`}</p>
                                                                                    </div>
                                                                                );
                                                                            })}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="tw:flex! tw:justify-center! tw:items-center! text-center">
                                                                    <CollapseDownIcon
                                                                        onClick={() => toggleOpen(`additional-${index}-${groupIndex}`)}
                                                                        style={{
                                                                            cursor: "pointer",
                                                                            transition: "transform 0.3s ease",
                                                                            transform: openItems.includes(`additional-${index}-${groupIndex}`) ? "rotate(180deg)" : "rotate(0deg)",
                                                                        }}
                                                                    />
                                                                </div>
                                                            </>
                                                        ) : (
                                                            <div className="border-top mt-2">
                                                                {(group.items || []).map((additionalItem, additionalIndex) => {
                                                                    const itemName = additionalItem?.name || "-";
                                                                    const additionalItemServiceDate = additionalItem?.serviceDate ? moment(additionalItem.serviceDate).locale("en").format("MMMM DD, YYYY") : "-";
                                                                    return (
                                                                        <div key={additionalIndex} className={`d-flex justify-content-between align-items-start ${additionalIndex > 0 ? "mt-2" : "pt-2"}`}>
                                                                            <div>
                                                                                <p className="tw:!font-hanken-grotesk py-0 mb-0 text-description">{itemName}</p>
                                                                                <p className="tw:!font-hanken-grotesk py-0 mb-0 fs-13 text-7C7B7B">{additionalItemServiceDate}</p>
                                                                                <p className="tw:!font-hanken-grotesk py-0 mb-0 fs-13 text-7C7B7B">{`${t("Quotation.LinkPage.Table.Qty")}: ${additionalItem?.qty}`}</p>
                                                                            </div>
                                                                            <p className="tw:!font-hanken-grotesk m-0 p-0 text-nowrap text-description">{`${additionalItem?.totalPrice?.toLocaleString()}${t("Quotation.LinkPage.JPY")}`}</p>
                                                                        </div>
                                                                    );
                                                                })}
                                                            </div>
                                                        )}
                                                    </div>
                                                ))}
                                                <div className="bg-DCDDDE p-3 ">
                                                    <div className="d-flex justify-content-between">
                                                        <p className="tw:!font-hanken-grotesk m-0 fs-14">{t("Quotation.LinkPage.Table.Subtotal")}</p>
                                                        <b className="tw:!font-hanken-grotesk m-0 p-0">
                                                            {item?.bookingItems
                                                                ? `${(
                                                                    (item?.bookingItems || []).reduce(
                                                                        (subtotal, b) => subtotal + (b.discountedPrice ? b.discountedPrice : b.totalPrice),
                                                                        0
                                                                    ) +
                                                                    getAllAdditionalItems(item).reduce(
                                                                        (subtotal, additionalItem) => subtotal + Number(additionalItem?.totalPrice || 0),
                                                                        0
                                                                    )
                                                                ).toLocaleString()}${t("Quotation.LinkPage.JPY")}`
                                                                : `0${t("Quotation.LinkPage.JPY")}`}
                                                        </b>
                                                    </div>
                                                </div>
                                                {
                                                    item?.message?.length > 0 && (
                                                        <>
                                                            <div className="bg-gold-grey-F9F9F9 p-3 border-bottom">
                                                                <div className="d-flex justify-content-between align-items-center">
                                                                    <div className="">
                                                                        <b className="tw:!font-hanken-grotesk tw:!text-[15px]">
                                                                            {t("Quotation.LinkPage.TransferNotes")}
                                                                        </b>
                                                                        <p className="tw:!font-hanken-grotesk pt-3 mb-0">
                                                                            {item?.message ? (
                                                                                item.message.map((m) => <p className="tw:!font-hanken-grotesk m-0 tw:!text-[13px]">{m.note}</p>)
                                                                            ) : (
                                                                                <p className="tw:!font-hanken-grotesk m-0 tw:!text-[13px]">-</p>
                                                                            )}
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </>
                                                    )
                                                }
                                            </>
                                        ))}
                                        {/* Standalone Additional Items (mobile) */}
                                        {quotationDetail?.standaloneItemsGroups?.length > 0 && (
                                            <>
                                                <div className="bg-7C7B7B p-3">
                                                    <p className="tw:!font-hanken-grotesk m-0 text-white">
                                                        {t("Quotation.LinkPage.AdditionalItems") || "Additional Items"}
                                                    </p>
                                                </div>
                                                {quotationDetail.standaloneItemsGroups.map((group, groupIndex) => (
                                                    <div className="p-3 border-bottom" key={`mobile-standalone-group-${groupIndex}`}>
                                                        {group.heading && (
                                                            <div className="d-flex justify-content-between align-items-center">
                                                                <b className="tw:!font-hanken-grotesk">{group.heading}</b>
                                                            </div>
                                                        )}
                                                        <div className={group.heading ? "border-top mt-2" : ""}>
                                                            {(group.items || []).map((additionalItem, additionalIndex) => {
                                                                const itemName = additionalItem?.name || "-";
                                                                const itemServiceDate = additionalItem?.serviceDate ? moment(additionalItem.serviceDate).locale("en").format("MMMM DD, YYYY") : "-";
                                                                return (
                                                                    <div key={additionalIndex} className={`d-flex justify-content-between align-items-start ${additionalIndex > 0 ? "mt-2" : "pt-2"}`}>
                                                                        <div>
                                                                            <p className="tw:!font-hanken-grotesk py-0 mb-0 text-description">{itemName}</p>
                                                                            <p className="tw:!font-hanken-grotesk py-0 mb-0 fs-13 text-7C7B7B">{itemServiceDate}</p>
                                                                            <p className="tw:!font-hanken-grotesk py-0 mb-0 fs-13 text-7C7B7B">{`${t("Quotation.LinkPage.Table.Qty")}: ${additionalItem?.qty || ""}`}</p>
                                                                        </div>
                                                                        <p className="tw:!font-hanken-grotesk m-0 p-0 text-nowrap text-description">{`${Number(additionalItem?.totalPrice || 0).toLocaleString()}${t("Quotation.LinkPage.JPY")}`}</p>
                                                                    </div>
                                                                );
                                                            })}
                                                        </div>
                                                    </div>
                                                ))}
                                                <div className="bg-DCDDDE p-3">
                                                    <div className="d-flex justify-content-between">
                                                        <p className="tw:!font-hanken-grotesk m-0 fs-14">{t("Quotation.LinkPage.Table.Subtotal")}</p>
                                                        <b className="tw:!font-hanken-grotesk m-0 p-0">
                                                            {`${computeStandaloneItemsTotal(quotationDetail.standaloneItemsGroups).toLocaleString()}${t("Quotation.LinkPage.JPY")}`}
                                                        </b>
                                                    </div>
                                                </div>
                                            </>
                                        )}

                                        <div className="bg-dark text-white p-3 ">
                                            <div className="d-flex justify-content-between">
                                                <p className="tw:!font-hanken-grotesk py-0 my-0 text-white fs-10">
                                                    <b className="tw:!font-hanken-grotesk fs-14">{t("Quotation.LinkPage.Table.Total")}</b> {" "}
                                                    {t("Quotation.LinkPage.Table.TaxInclude")}
                                                </p>
                                                <b className="tw:!font-hanken-grotesk m-0 p-0">
                                                    {`${computeQuotationTotalAmount(quotationDetail).toLocaleString()}${t("Quotation.LinkPage.JPY")}`}
                                                </b>
                                            </div>
                                        </div>
                                    </div>
                                    {quotationDetail?.notes && (
                                        <div className="p-3">
                                            <p className="tw:!font-hanken-grotesk noto mx-0 mt-0 mb-1" style={{ fontWeight: "700" }}>
                                                {t("Quotation.LinkPage.QuotationNotes")}
                                            </p>
                                            <p className="tw:!font-hanken-grotesk">
                                                {quotationDetail?.notes}
                                            </p>
                                        </div>
                                    )}
                                </div>
                            ) : (
                                <PDFViewer width={"100%"} height={"1000"}>
                                    <QuotationDocument data={quotationDetail} />
                                </PDFViewer>
                            )}
                            <div className={`tw:px-0 tw:md:px-4 ${showTNCTables ? "d-block" : "d-none"}`}>
                                <div className="row tw:m-0 tw:md:m-4">
                                    <div className="col">
                                        <h5>
                                            {t("Quotation.LinkPage.TermsAndConditions")}
                                        </h5>
                                        <hr className="divider-grey" />
                                        <TNCTables />
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </div>

                {showModal && (
                    <>
                        <CustomerLogin
                            useModal={true}
                            modalId={"login"}
                            openModal={showModal}
                            autoOpen={true}
                            isQuotation={true}
                            redirect={"/quotation/" + quotationId}
                        />

                        <CustomerRegister useModal={true} modalId={"register"} />
                    </>
                )}

                {showModaSelectPaymentMethod && quotationDetail != null &&
                    <PaymentMethodSelectionModal
                        show={showModaSelectPaymentMethod}
                        title={t("PaymentMethodSelection.Title")}
                        size="modal-lg"
                        onClose={() => handleModalSelectPaymentMethod(false)}
                        paymentMethods={quotationDetail?.user.individualDetail.paymentMethod}
                        selectedPaymentMethod={selectedPaymentMethod}
                        handleSelectedPaymentMethod={handleSelectedPaymentMethod}
                        payButtonAuthenticatedUser={payButtonAuthenticatedUser}
                        quotationDetail={quotationDetail}
                        handleSetNewCard={handleSetNewCard}
                        handleDeleteCard={handleDeleteCard}
                        addPaymentMethodHandler={addPaymentMethodHandler}
                    />
                }

                <ClientInfoFormModal
                    show={showClientInfoModal.show}
                    onClose={handleCloseClientInfoModal}
                    onSuccessUpdateClient={(user) => {
                        showClientInfoModal.type === "pay" ? payButtonHandle(user) : downloadButtonClickFunc(user)
                    }}
                    quotationDetail={quotationDetail}
                    buttonLabel={`${showClientInfoModal.type === "pay" ? t("Quotation.LinkPage.PayNow") : t("Quotation.LinkPage.Download")}`}
                    icon={showClientInfoModal.type === "pay" ? <ArrowRightIcon color="white" size={15} /> : <DownloadNarrowIcon />}
                    isIconBeforeText={showClientInfoModal.type === "pay" ? false : true}
                />

                {eligibilityPayButton(quotationDetail) && (
                    <div style={stickyButtonStyle} className="no-print tw:w-full">
                        <div className="tw:flex tw:justify-center tw:items-center gap-2">
                            <button
                                className="bg-gold rounded"
                                onClick={() => handleOpenClientInfoModal("pay")}
                                style={{ width: "min(360px, 55vw)" }}
                            >
                                <div className="tw:flex! tw:justify-center! tw:items-center! tw:gap-2! tw:px-4! tw:py-3!">
                                    <p className="tw:!font-hanken-grotesk m-0 text-white">{t("Quotation.LinkPage.PayNow")}</p>
                                    <ArrowRightIcon color="white" size={15} />
                                </div>
                            </button>
                            <LanguageCard dropUp />
                        </div>
                    </div>
                )}
                <Footer />
            </Fragment>
        </>
    );
};
